// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle_sectionTitle__6lDz3","clickable":"SectionTitle_clickable__7qUYS"};